<template>
  <button
    v-if="message"
    type="button"
    class="ffh ffh-blocking"
    :data-testid="`${testidPrefix}-blocking`"
    @click="$emit('go')"
  >
    <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
    {{ message }}
  </button>
  <span v-else-if="ready" class="ffh ffh-ready" :data-testid="`${testidPrefix}-ready`">
    <i class="fas fa-check" aria-hidden="true"></i>
    {{ readyText }}
  </span>
</template>

<script setup>
/**
 * CE QUI MANQUE, DIT AVANT LE CLIC, à côté du bouton qui refuse.
 *
 * Extrait de `quote-besoin/BesoinFooterHint.vue`, où il répondait à un défaut
 * qu'on retrouve partout : le message expliquant le refus était réservé à un
 * toast déclenché AU CLIC — sur un bouton désactivé, donc jamais atteint.
 * Ici la phrase porte une raison, donc elle se lit ; elle mène à la section
 * concernée, donc elle se clique.
 *
 * PRÉSENTATIONNEL : des props entrent, `go` sort.
 */
defineProps({
  /** Ce qui reste à faire, ou null quand plus rien ne bloque. */
  message: {
    type: String,
    default: null
  },
  /**
   * Vrai quand l'absence de message vaut « tout est bon » — et non « il n'y a
   * rien à valider » (formulaire pas encore chargé, écran en lecture seule).
   */
  ready: {
    type: Boolean,
    default: false
  },
  /** Phrase affichée quand plus rien ne bloque. */
  readyText: {
    type: String,
    default: 'Tout est prêt.'
  },
  /** Préfixe des `data-testid` (`<prefix>-blocking`, `<prefix>-ready`). */
  testidPrefix: {
    type: String,
    default: 'form'
  }
})

defineEmits(['go'])
</script>

<style scoped>
.ffh {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
  max-width: 760px;
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-md);
  font-family: inherit;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: 1.4;
  text-align: left;
}

.ffh-blocking {
  border: 1px solid var(--color-warning-lighter, #fdeeba);
  background: var(--color-warning-lightest);
  color: #8a5a00;
  cursor: pointer;
}

.ffh-blocking:hover {
  border-color: var(--color-warning, #eab308);
}

.ffh-blocking:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.ffh-ready {
  border: 1px solid var(--color-success-lighter, #c7ecd6);
  background: var(--color-success-lightest);
  color: var(--color-success-darker);
}

@media (max-width: 768px) {
  /* Le pied s'empile : la phrase y prend alors toute la largeur. En 12 px elle
     tient sur deux lignes au lieu de quatre, ce qui rend une trentaine de
     pixels au corps. */
  .ffh {
    max-width: none;
    font-size: var(--font-size-xs);
    line-height: 1.35;
  }
}
</style>
